import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, ModalProps } from 'antd';
import styles from './ModalTitle.module.scss';

interface Props {
  title: string;
  subtitle: string;
  onCancel?: ModalProps['onCancel'];
}

const ModalTitle: React.FC<Props> = (props) => {
  const { title, subtitle, onCancel } = props;

  return (
    <div className={styles.title_container}>
      <div className={styles.title}>
        <h5>{title}</h5>
        <p>{subtitle}</p>
      </div>
      <Button type="text" icon={<CloseOutlined />} onClick={onCancel} />
    </div>
  );
};

export default ModalTitle;
